import { useEffect } from 'react';
import { useTheme } from 'styled-components';
import { useDispatch } from 'react-redux';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import getCurrentBreak from '@sdk/automatedBreaks/helpers/getCurrentBreak';

import { useAutomatedBreaksContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/AutomatedBreaksProvider/AutomatedBreaksProvider';
import { useClockedInViewContext } from '@kiosk/common/components/UserPanel/ClockedInViewWithAutomatedBreaks/ClockedInViewProvider/ClockedInViewProvider';
import { setHideGreeting } from '@kiosk/timeClock/actions';

export const useBackTooSoonView = () => {
  const { colors } = useTheme();
  const dispatch = useDispatch();
  const { setAutomatedBreakScreen } = useAutomatedBreaksContext();
  const { shift } = useClockedInViewContext();

  const { breakRecords } = getBreaksSummary(shift.timesheetEntries, shift.dtstart, shift.dtend);
  const currentBreak = getCurrentBreak(breakRecords);
  const { duration } = currentBreak.settings;

  useEffect(() => {
    dispatch(setHideGreeting(true));

    return () => {
      dispatch(setHideGreeting(false));
    };
  }, []);

  return { colors, duration, setAutomatedBreakScreen };
};
